import { render, staticRenderFns } from "./insurers-edit.vue?vue&type=template&id=3861c89d&scoped=true"
import script from "./insurers-edit.vue?vue&type=script&lang=js"
export * from "./insurers-edit.vue?vue&type=script&lang=js"
import style0 from "./insurers-edit.vue?vue&type=style&index=0&id=3861c89d&prod&lang=css"
import style1 from "./insurers-edit.vue?vue&type=style&index=1&id=3861c89d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3861c89d",
  null
  
)

export default component.exports